import { usePageTitle } from "@/lib/api";
import { SITE } from "@/lib/content";

const SECTIONS = [
  ["Information We Collect", "When you submit a contact or sponsorship form, we collect your name, email address, phone number and message. Parent portal accounts store the account holder's name, email, the athlete names provided, and registration or payment status recorded by our staff."],
  ["How We Use Information", "Information is used only to respond to inquiries, manage tryout and team participation, and communicate with families. We do not sell or rent personal information."],
  ["Athlete & Minor Privacy", "Athlete profiles, photographs and identifying information are published only with the permission of a parent or guardian. Families may request removal at any time by contacting us."],
  ["Account Security", "Passwords are encrypted and staff access is restricted by role (administrator, coach, parent). Private team updates are visible only to approved accounts."],
  ["Third-Party Services", "Tryout registration links may take you to third-party services such as Jotform or Eventbrite, which have their own privacy policies."],
  ["Contact", `Questions about this policy? Contact Tri County Allstars at ${SITE.email} or ${SITE.phone}.`],
];

export default function Privacy() {
  usePageTitle("Privacy Policy");
  return (
    <div className="bg-pitch pt-36 pb-20" data-testid="privacy-page">
      <div className="wrap max-w-3xl">
        <p className="eyebrow">Legal</p>
        <h1 className="h-display text-5xl sm:text-6xl mt-3">Privacy Policy</h1>
        <div className="mt-10 space-y-8">
          {SECTIONS.map(([t, b]) => (
            <div key={t}><h2 className="font-display text-2xl font-extrabold uppercase italic text-gold">{t}</h2><p className="mt-2 text-slate-300 leading-relaxed">{b}</p></div>
          ))}
        </div>
      </div>
    </div>
  );
}
